export default __webpack_public_path__ + "static/media/arrow_right.82116f2a.svg";